import styled from '@emotion/styled';
import { BaseCard } from '../styled';
import { H3 } from 'ds/components/typography';


export const Root = styled(BaseCard)`
  height: 276px;
`;

export const AgencyName = styled(H3)<{ isRegistered: boolean; verifiedIconColor: string; }>`
  ${({ theme, isRegistered, verifiedIconColor }) => `
    display: flex;
    align-items: center;
    color: ${isRegistered ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey3};
    white-space: nowrap;
    max-width: 100%;
    text-decoration: none;
    > h3 {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    > svg {
      flex-shrink: 0;
      margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(0.5)};
      > path {
        fill: ${verifiedIconColor ? verifiedIconColor : theme.colors.brand.lighter};
      }
    }
  `}
`;
